import {
    VRCORE_GET_JOB_PACKS,
    VRCORE_JOB_PACK_PROFILE_SELECTED_INDEX,
    VRCORE_PROFILE_EDIT_SELECTED_TAB,
    VRCORE_POST_EDITED_USER,
    VRCORE_REMOVE_JOB_PACK,
    VRCORE_GET_TEMPLATES,
    GET_REPORT_TITLES,
    VRCORE_GET_ALL_USERS,
    VRCORE_REMOVE_FILE,
    VRCORE_UPLOAD_FILE,
    VRCORE_SET_FILES
    
} from "./types";

const INITIAL_STATE = {
    requesting: false,
    job_packs: false,
    users: false,
    selectedJobPackIndex: 0,
    removing:false,
    templateList:false,
    reportTitles:false,
    uploadedFiles:[]

};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case VRCORE_GET_JOB_PACKS.REQUEST: {
            return { ...state, requesting: true, job_packs: false };
        }
        case VRCORE_GET_JOB_PACKS.SUCCESS: {
            return { ...state, requesting: false, job_packs: action.payload };
        }
        case VRCORE_GET_JOB_PACKS.FAIL: {
            return { ...state, requesting: false, job_packs: false };
        }
        case VRCORE_JOB_PACK_PROFILE_SELECTED_INDEX: {
            return { ...state, selectedJobPackIndex: action.payload };
        }
        case VRCORE_PROFILE_EDIT_SELECTED_TAB: {
            return { ...state, selectedTab: action.payload };
        }
        case VRCORE_POST_EDITED_USER.REQUEST: {
            return { ...state, requesting: true };
        }
        case VRCORE_POST_EDITED_USER.SUCCESS: {
            return { ...state, requesting: false };
        }
        case VRCORE_POST_EDITED_USER.FAIL: {
            return { ...state, requesting: false };
        }
        case VRCORE_REMOVE_JOB_PACK.REQUEST: {
            return { ...state, removing: true };
        }
        case VRCORE_REMOVE_JOB_PACK.SUCCESS: {
            return { ...state, removing: false };
        }
        case VRCORE_REMOVE_JOB_PACK.FAIL: {
            return { ...state, removing: false };
        }
        case VRCORE_GET_TEMPLATES.REQUEST: {
            return { ...state, requesting: true, templateList: false };
        }
        case VRCORE_GET_TEMPLATES.FAIL: {
            return { ...state, requesting: false, templateList: false };
        }
        case VRCORE_GET_TEMPLATES.SUCCESS: {
            return {
                ...state,
                requesting: false,
                templateList: action.payload
            };
        }
        case VRCORE_GET_ALL_USERS.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case VRCORE_GET_ALL_USERS.SUCCESS: {
            return { ...state, users: action.payload, requesting: false };
        }
        case VRCORE_GET_ALL_USERS.FAIL: {
            return { ...state, users: false, requesting: false };
        }
        case VRCORE_UPLOAD_FILE.REQUEST: {
            return { ...state, requesting: true};
        }
        case VRCORE_UPLOAD_FILE.SUCCESS: {

            return { ...state, uploadedFiles: [...state.uploadedFiles, action.payload], requesting: false };
        }
        case VRCORE_UPLOAD_FILE.FAIL: {
            return { ...state, requesting: false };
        }
        case VRCORE_REMOVE_FILE.REQUEST: {
            return { ...state, requesting: true};
        }
        case VRCORE_REMOVE_FILE.SUCCESS: {

            return { ...state, uploadedFiles:action.payload, requesting: false };
        }
        case VRCORE_REMOVE_FILE.FAIL: {
            return { ...state, requesting: false };
        }
        case VRCORE_SET_FILES.REQUEST: {
            return { ...state, requesting: true};
        }
        case VRCORE_SET_FILES.SUCCESS: {

            return { ...state, uploadedFiles:action.payload, requesting: false };
        }
        case VRCORE_SET_FILES.FAIL: {
            return { ...state, requesting: false };
        }
        case GET_REPORT_TITLES.REQUEST: {
            return { ...state, requesting: true, reportTitles: false };
          }
          case GET_REPORT_TITLES.SUCCESS: {
              return {
                  ...state,
                  requesting: false,
                  reportTitles: action.payload
              };
          }
          case GET_REPORT_TITLES.FAIL: {
              return { ...state, requesting: false, reportTitles: false };
          }
        default: {
            return state;
        }
    }
};
